module.exports = __webpack_public_path__ + "f159ec168ea083c41505dce64eb31923.svg";